<template>
  <label>
    <select :name="name"
            :value="value"
            @input="updateValue"
            @focus="$emit('focus', $event)"
            @blur="$emit('blur', $event)"
            @click="$emit('click', $event)"
            class="select w4_0em"
            :class="{ 'error': isInvalid }"
            :disabled="isDisabled"
    >
      <slot :options="options"></slot>
    </select>
  </label>
</template>
<script>
export default {
  props: {
    value: {},
    label: { type: String },
    name: { type: String, require: true },
    options: { type: Array, required: true },
    isInvalid: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false }
  },

  methods: {
    updateValue (e) {
      const value = e.target.selectedOptions.length ? e.target.selectedOptions[0]._value : null
      this.$emit('input', value)
      this.$emit('selected', value)
    }
  }
}
</script>
